import { PartyPopper, ReceiptText } from '@/lib/icons'

/**
 * `docs/03-app-flow.md` "Bo'sh holatlar": "To'lovlar bo'sh — 'To'lanadigan summa yo'q'".
 * Bu — YAXSHI xabar (hech kim kutayotgan pul yo'q), shuning uchun tinch/ijobiy ohangda.
 */
export function PayoutsEmptyState({ message }: { message: string }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="rounded-full bg-urgency-done/10 p-4">
        <PartyPopper size={28} className="text-urgency-done-text" aria-hidden="true" />
      </div>
      <p className="max-w-xs text-sm text-app-text">{message}</p>
    </div>
  )
}

/** Umumiy (yaxshi/yomon xabarga bog'liq bo'lmagan) bo'sh holat — masalan Tarix tabi. */
export function PayoutsNeutralEmptyState({ message }: { message: string }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="rounded-full bg-app-card p-4">
        <ReceiptText size={28} className="text-app-hint" aria-hidden="true" />
      </div>
      <p className="max-w-xs text-sm text-app-hint">{message}</p>
    </div>
  )
}
